import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import translate from 'components/hoc/translate';
import { fetchProductMembership, fetchProductMemberships } from 'store/actions/product-memberships/fetchProductMemberships';
import SelectField from 'components/input/SelectField/SelectField';
import { filter } from 'lodash';
import { formValueSelector } from 'redux-form';

class ProductMembershipInputField extends Component {
    componentDidMount() {
        if (this.props.input.value) {
            this.props.fetchProductMembership(this.props.input.value);
        }
    }

    componentDidUpdate(prevProps) {
        const {
            productId,
            loading,
            choices,
            fetchProductMemberships,
        } = this.props;

        if ((productId !== prevProps.productId) ||
            (!loading && choices.length !== prevProps.choices.length)
        ) {
            fetchProductMemberships(productId);
        }
    }

    render() {
        const {
            choices,
            input,
            input: {
                name,
            },
            loading,
            label,
            meta,
            meta: {
                touched,
                error,
            },
        } = this.props;

        return (
            <SelectField
                choices={ choices }
                disabled={ loading }
                fullWidth={ true }
                input={ input }
                meta={ {
                    ...meta,
                    touched: touched && choices.length,
                    error,
                } }
                name={ name }
                label={ label }
                optionText='name'
                optionValue='id'
            />
        );
    }
}

ProductMembershipInputField.propTypes = {
    choices: PropTypes.array,
    fetchProductMembership: PropTypes.func,
    fetchProductMemberships: PropTypes.func,
    input: PropTypes.shape({
        name: PropTypes.string.isRequired,
        onChange: PropTypes.func.isRequired,
        value: PropTypes.oneOfType([
            PropTypes.number,
            PropTypes.string,
        ]),
    }),
    label: PropTypes.string,
    loading: PropTypes.bool,
    meta: PropTypes.shape({
        error: PropTypes.string,
        form: PropTypes.string.isRequired,
        touched: PropTypes.bool,
    }).isRequired,
    productId: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string,
    ]),
};

const mapStateToProps = (state, props) => {
    const resourceState = state['product-memberships'];
    const {
        meta: {
            form,
        },
    } = props;

    const productId = formValueSelector(form)(state, 'product_id');

    return {
        choices: filter(resourceState.data, { product_id: productId }),
        productId,
        loading: resourceState.loading,
    };
};

const mapDispatchToProps = (dispatch) => {

    return {
        fetchProductMembership: (id) => {
            dispatch(fetchProductMembership({ id }));
        },
        fetchProductMemberships: (product_id) => {
            dispatch(fetchProductMemberships({
                product_id,
            }));
        },
    };
};

const enhance = compose(
    translate,
    connect(mapStateToProps, mapDispatchToProps),
);

export default enhance(ProductMembershipInputField);



// WEBPACK FOOTER //
// ./src/pages/users/product-memberships/ProductMembershipInputField.js